export default __webpack_public_path__ + "static/media/call-outgoing.b90cb039.svg";